import { Typography } from "@dealer-center/core-components";
import { Locale } from "@dealer-center/ddc-core-utils";

// Relies on the parent Configuration having called Locale.setLabelsOnce(LABELS).
export const MyInfo = () => {
  return (
    <Typography variant={"h1"}>
      {Locale.getText("MANAGE_YOUR_USER_INFORMATION") as string}
    </Typography>
  );
};
